import { premiumBuildingsPrices } from "@/config/constants";
import { formatPercent } from "@/utils/format";
import { FrameName } from "../config";
import { ResourceType } from "../config/resources";
import TileEntity from "../TileEntity";

class TaxOfficeBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.TAX_OFFICE;

	public static readonly baseGemsPrice =
		premiumBuildingsPrices[this.frameName];

	public get description(): string {
		return super.description.replace(
			"{percent}",
			formatPercent(
				(this.config.production.get(
					ResourceType.PRODUCTION_ONCLICK_RESOURCE_MULTIPLIER,
				)! as number) - 1,
			),
		);
	}
}

export default TaxOfficeBuildingTileEntity;
